import React from "react";
import Button from "@material-ui/core/Button/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import { Slide } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import SectionHeader from "../../../../components/UI/SectionHeader";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  paper: {
    width: "100%",
  },
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  dialogContent: {
    maxHeight: 300,
  },
});

const PasEmailSentAlert = (props) => {
  const { classes, show, handleModalClose } = props;

  return (
    <Dialog
      open={show}
      TransitionComponent={Slide}
      TransitionProps={{ direction: "up" }}
      onClose={handleModalClose}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      aria-labelledby="notification-modal-title"
      maxWidth={"sm"}
      scroll={"paper"}
      classes={{ paper: classes.paper }}
    >
      <DialogTitle id="notification-modal-title" disableTypography>
        <SectionHeader text={"Notice"} />
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant={"subtitle1"}></Typography>
        <Typography variant={"body1"}>
          Thank you for submitting your Pershing Advisor Solutions Rep Code
          request! Please allow 1-2 business days for PAS to complete a
          background review of your information. If additional disclosures are
          found, please expect delays up to 1 week. Once you receive your PAS
          Rep Code, you will be able to onboard clients through PAS. Thank you
          for your patience.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleModalClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(PasEmailSentAlert);



// WEBPACK FOOTER //
// ./src/containers/UserRepCodes/components/PasEmailRequestedModal/index.jsx